/*
 * BORN FORGED — keeps the product page title in sync with the selected colour.
 * "HORIZON — Eclipse" becomes "HORIZON — Crystal" as soon as the customer picks Crystal,
 * without reloading. The selected variant is read from the theme's own variant picker
 * (checked radio / selected option), then from its JSON after a re-render, then from the
 * add-to-cart form, then from ?variant=ID.
 */
(() => {
  if (window.__bfVariantTitle) return;
  window.__bfVariantTitle = true;

  const cache = new Map();
  const dataFor = (productId) => {
    if (cache.has(productId)) return cache.get(productId);
    const el = document.querySelector(`script[data-bf-vtitle-data="${productId}"]`);
    let data = null;
    try { data = el ? JSON.parse(el.textContent) : null; } catch (e) { data = null; }
    cache.set(productId, data);
    return data;
  };

  const selectedVariantId = (scope, productId) => {
    const picker = scope.querySelector(`variant-picker[data-product-id="${productId}"]`) || scope.querySelector('variant-picker');
    if (picker) {
      const radio = picker.querySelector('input[type="radio"]:checked[data-variant-id]');
      if (radio && radio.dataset.variantId) return radio.dataset.variantId;
      const option = picker.querySelector('select option:checked[data-variant-id]');
      if (option && option.dataset.variantId) return option.dataset.variantId;
      const json = picker.querySelector('script[type="application/json"]');
      if (json) {
        try { const v = JSON.parse(json.textContent); if (v && v.id) return String(v.id); } catch (e) {}
      }
    }
    const input = scope.querySelector('form[action*="/cart/add"] [name="id"]');
    if (input && input.value) return input.value;
    return new URL(window.location.href).searchParams.get('variant');
  };

  const sync = () => {
    document.querySelectorAll('[data-bf-vtitle]').forEach((h1) => {
      const productId = h1.dataset.productId;
      const data = dataFor(productId);
      const span = h1.querySelector('[data-bf-vtitle-variant]');
      if (!data || !span) return;
      const scope = h1.closest('.shopify-section') || document;
      const id = selectedVariantId(scope, productId);
      const name = id && data.variants[String(id)];
      if (!name) return;
      const text = data.separator + name;
      if (span.textContent !== text) span.textContent = text;
    });
  };

  let queued = false;
  const queue = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; sync(); });
  };

  // Colour picked (native picker, BF colour strip or dropdown): update right away.
  document.addEventListener('change', queue, true);
  // Theme re-renders (variant picker morph, form update) and back/forward navigation.
  new MutationObserver(queue).observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['checked', 'value', 'selected'] });
  window.addEventListener('popstate', queue);
  window.addEventListener('pageshow', queue);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();
})();
